/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * An error at the fault of the client sending invalid input
 * @export
 * @interface BadRequestErrorResponseContent
 */
export interface BadRequestErrorResponseContent {
    /**
     * Message with details about the error
     * @type {string}
     * @memberof BadRequestErrorResponseContent
     */
    message: string;
}


/**
 * Check if a given object implements the BadRequestErrorResponseContent interface.
 */
export function instanceOfBadRequestErrorResponseContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "message" in value;

    return isInstance;
}

export function BadRequestErrorResponseContentFromJSON(json: any): BadRequestErrorResponseContent {
    return BadRequestErrorResponseContentFromJSONTyped(json, false);
}

export function BadRequestErrorResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): BadRequestErrorResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': json['message'],
    };
}

export function BadRequestErrorResponseContentToJSON(value?: BadRequestErrorResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
    };
}

